import { PauseAdType } from 'tag/ts/tag/model/type/ads/PauseAdType';
import { AbstractPauseAdUtilities } from 'tag/ts/tag/ads/pause/AbstractPauseAdUtilities';
export class GAMPauseAdUtilities extends AbstractPauseAdUtilities {
    constructor(argument) {
        super({ tag: argument.tag, name: 'GAMPauseAdUtilities', type: PauseAdType.GAM });
    }
    getAdCallURL = () => {
        const siteSessionData = this?.tag?.model?.siteUtilities?.siteSessionData;
        let kidsContent = false;
        let adCallURL = 'https://pubads.g.doubleclick.net/gampad/adx?iu=/8264/vaw-can/desktop/';
        const partner = this.params?.CONTENT?.partner || 'cbs';
        adCallURL += partner;
        adCallURL = this.utils.URL.addParam('sz', '640x360', adCallURL);
        adCallURL = this.utils.URL.addParam('cmsid', '2289', adCallURL);
        adCallURL = this.utils.URL.addParam('cust_params', 'type=pause', adCallURL);
        adCallURL = this.utils.URL.addParam('partner', partner, adCallURL);
        adCallURL = this.utils.URL.addParam('vid', this.apiMetadata.contentId, adCallURL);
        adCallURL = this.utils.URL.addParam('c', Math.round(Math.random() * Date.now()).toString(), adCallURL);
        if (this.utils.Type.isObject(this.params?.AD?.PAUSE?.adCallParams)) {
            Object.keys(this.params.AD.PAUSE.adCallParams).forEach((key) => {
                adCallURL = this.utils.URL.addParam(key, this.params.AD.PAUSE.adCallParams[key], adCallURL);
            });
        }
        const adCallURLParsedParams = this.utils.URL.queryStringToObject(this.utils.URL.parser(adCallURL).search);
        let custParamsValue = this.utils.URL.queryStringToObject(adCallURLParsedParams.cust_params);
        if (this.utils.Type.isObject(siteSessionData) && !this.utils.Type.isEmpty(siteSessionData)) {
            ['tfcd', 'ppid'].forEach((param) => {
                if (this.utils.Type.isEmpty(siteSessionData[param]) === false) {
                    adCallURLParsedParams[param] = siteSessionData[param];
                }
            });
        }
        const cust_params = this.tag.model.adUtilities.getIMACustParams();
        if (this.utils.Type.isObject(cust_params)) {
            Object.keys(cust_params).forEach((key) => {
                const value = cust_params[key];
                custParamsValue[key] = value;
                switch (key) {
                    case 'tfcd':
                        kidsContent = (parseInt(value) === 1);
                        break;
                    case 'ppid':
                        adCallURLParsedParams[key] = value;
                        break;
                }
            });
            if (!this.utils.Type.isEmpty(this?.apiMetadata?.vTag) && this.utils.Type.isString(this?.apiMetadata?.vTag)) {
                const vtagObj = this.utils.URL.queryStringToObject(this?.apiMetadata?.vTag.replace(/;/g, '&'));
                this?.logger?.log('getAdCallURL:', 'VTAG parsed:', vtagObj);
                Object.keys(vtagObj).forEach((key) => {
                    switch (key) {
                        case 'dpart':
                        case 'show':
                            custParamsValue[key] = vtagObj[key];
                            break;
                    }
                });
            }
            else {
                this?.logger?.warn('getAdCallURL:', 'MPX Metadata does not exist! Can not process VTAG!');
            }
            custParamsValue = this.utils.GAM.processCustParams(this.utils.URL.objectToQueryString(custParamsValue));
            adCallURLParsedParams.cust_params = custParamsValue;
        }
        adCallURL = adCallURL.split('?')[0] + '?' + this.utils.URL.objectToQueryString(adCallURLParsedParams);
        return adCallURL;
    };
    processResponse = (xml) => {
        let imageSource = undefined;
        let clickThrough = undefined;
        const rootNode = xml.querySelector('Companion[width="848"]')
            ||
                xml.querySelector('companion[width="848"]');
        if (this.utils.Type.isElement(rootNode)) {
            const image = rootNode.querySelector('StaticResource[creativeType*="image/"]')
                ||
                    rootNode.querySelector('staticresource[creativeType*="image/"]');
            imageSource = image && image.textContent ? image.textContent.trim() : undefined;
            const clickURL = rootNode.querySelector('CompanionClickThrough')
                ||
                    rootNode.querySelector('companionclickthrough');
            clickThrough = clickURL && clickURL.textContent ? clickURL.textContent.trim() : undefined;
        }
        return {
            imageSource: imageSource,
            clickThrough: clickThrough,
            impression: this.impression
        };
    };
}
